import { apiSlice } from "@/shared/api/api-slice"

import type { GetRatingHistoryRequest, RatingHistoryResponse } from "./types"

export const getRatingHistoryApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["RatingHistory"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getRatingHistory: builder.query<RatingHistoryResponse, GetRatingHistoryRequest>({
        query: ({ chatId, userId, period }) => {
          const params = new URLSearchParams({
            chat_id: String(chatId),
            user_id: String(userId)
          })

          if (period) {
            params.set("period", period)
          }

          return `/api/v1/balance/history?${params.toString()}`
        },
        providesTags: (_result, _error, { chatId, userId }) => [
          { type: "RatingHistory" as const, id: `CHAT_${chatId}_USER_${userId}` }
        ]
      })
    })
  })

export const { useGetRatingHistoryQuery } = getRatingHistoryApi
